import { atom } from "jotai";
import useHttp from "../hooks/useHttp";

export const brandSEOLoadingStatusAtom = atom("idle");
export const brandSEOAtom = atom(null);

export const fetchBrandSEOAtom = atom(null, async (get, set, brandId) => {
  set(brandSEOLoadingStatusAtom, "loading");

  const { getBrandSEO } = useHttp();

  getBrandSEO(brandId)
    .then((response) => set(brandSEOAtom, response.seo))
    .finally(() => set(brandSEOLoadingStatusAtom, "idle"));
});
